<script>
	/* eslint-disable no-unused-vars */
	// Stores
	import UserStore from '@/Stores/UserStore.js';
	import RuleStore from '@/Stores/RuleStore.js';
	import ACLStore from '@/Stores/ACLStore.js';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Components
	import PillTextInput from '@/Components/PillTextInput.svelte';
	// Partials
	import AddTag from '@/Partials/User/_AddTag.svelte';

	export let user;

	let sending = false;
	let newTag = '';
	$: tags = (user && user.rules && user.rules.data && user.rules.data.sortBy('tag').pluck('tag').toArray()) ?? [];

	function addTag() {
		if (!$RuleStore.contains('tag', newTag) || newTag === '') return;
		tags = [...tags, newTag];
		newTag = '';
	}

	function removeTag(tag) {
		let index = tags.indexOf(tag);
		tags = [...tags.slice(0, index), ...tags.slice(index + 1)];
	}

	function updateRuleTags() {
		sending = true;
		UserStore.updateRuleTags(user.id, tags)
			.then(() => {
				notify({
					type: 'success',
					title: user.name,
					message: 'Rule Tags updated',
					timeout: 3
				});
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to update Rule Tags',
					timeout: 5
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if user}
	<div class="flex flex-col md:w-1/2 text-dark-grey bg-gray-50 min-h-48">
		<div class="flex items-center px-2 bg-dark-grey text-light">
			<h2 class="flex-1 py-2 text-xl italic font-sans-condensed">Rule Tags</h2>
			{#if $ACLStore && ACLStore.granted('users.update')}
				<div class="flex space-x-2">
					<button on:click={updateRuleTags} class="py-1 btn btn-primary"> Save</button>
				</div>
			{/if}
		</div>
		{#if $ACLStore && ACLStore.granted('users.update')}
			<AddTag bind:newTag selected={tags} on:click={addTag} />
		{/if}
		{#if $ACLStore && ACLStore.granted('users.read')}
			<div class="flex justify-center mt-2">
				{#each tags as tag}
					<PillTextInput
						action="remove"
						on:remove={() => removeTag(tag)}
						name={tag}
						bgColour="bg-indigo-500"
						className="m-2"
						label={tag}
						value={false}
					/>
				{/each}
			</div>
		{/if}
	</div>
{/if}
